import { ListingCoinRepas } from '@components/listing-coin-repas/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

const baseProduct = {
  productImage: imageMock,
  price: '99,31 €',
  ecoPart: '19,79 €',
  description: `Produit présenté :<br><b>Finition noir</b><br><b>99,31€</b> dont 0,31€ d'eco-part l'unité`,
  details:
    "<ul><li>Existe en plusieurs coloris</li><li>Vendu à l'unité</li><li>Hauteur table et plan de travail</li></ul>",
};

export const listingCoinRepasMock: Block<ListingCoinRepas> = {
  type: 'listing-coin-repas',
  data: {
    produits: [
      { ...baseProduct, name: '[[Pietement]]\\\\Clap', lifestyleImage: imageMock },
      { ...baseProduct, name: '[[Pietement]]\\\\Firenze' },
      { ...baseProduct, name: '[[Pietement]]\\\\Mahogany' },
      { ...baseProduct, name: '[[Pietement]]\\\\Firenze' },
      { ...baseProduct, name: '[[Pietement]]\\\\Clap' },
      { ...baseProduct, name: '[[Pietement]]\\\\Eclat', lifestyleImage: imageMock, isImageFirst: true },
      { ...baseProduct, name: '[[Pietement]]\\\\Firenze' },
      { ...baseProduct, name: '[[Pietement]]\\\\Mahogany' },
    ],
  },
};
